import Vue from 'vue'
import './cube-ui'
import App from './App.vue'
import router from './router/router'
import store from './store'
import 'amfe-flexible'

import Video from 'video.js'
import 'video.js/dist/video-js.css'

import 'quill/dist/quill.snow.css'

Vue.config.productionTip = false

Vue.prototype.$video = Video

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
